/**
 * Boot curtain handoff.
 *
 * The dark boot screen lives in public/index.html so it can paint before any
 * stylesheet or bundle exists. React used to drop a SECOND loader on top of it
 * (`min-h-[60vh]` inside the app shell), which is why the mark visibly jumped
 * from the middle of the viewport to a third of the way down. There is now one
 * node: React HOLDS the HTML curtain until the first route chunk has arrived,
 * then fades it out. Nothing is ever drawn twice.
 *
 * The curtain only leaves when BOTH are true — auth has resolved AND no route
 * chunk is still in flight — otherwise whichever finished first left a gap.
 */
let holds = 0;
let authReady = false;
let removeTimer = null;

const el = () => document.getElementById('splash-screen');

function maybeDismiss() {
  if (!authReady || holds > 0) return;
  const node = el();
  if (!node) return;
  node.classList.add('splash-hidden');
  if (removeTimer) clearTimeout(removeTimer);
  removeTimer = setTimeout(() => { node.remove(); removeTimer = null; }, 550);
}

export function bootSplashAuthReady() {
  authReady = true;
  maybeDismiss();
}

/** Keep the curtain up while a lazy route chunk loads. Returns false if it has already gone. */
export function holdBootSplash() {
  const node = el();
  if (!node) return false;
  holds += 1;
  if (removeTimer) { clearTimeout(removeTimer); removeTimer = null; }
  node.classList.remove('splash-hidden');
  return true;
}

export function releaseBootSplash() {
  holds = Math.max(0, holds - 1);
  maybeDismiss();
}

// Failsafe: a chunk that never arrives must not leave someone staring at a
// locked screen. After 8s the curtain comes down whatever happened.
setTimeout(() => { authReady = true; holds = 0; maybeDismiss(); }, 8000);
